import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationDependenciesGet = {
    path: "/release/dependencies",
    method: ERouteHttpVerb.GET
};
export { routeLocationDependenciesGet };
